import React from 'react';
import { FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EMPTY_STRING } from '../../utils/constants';

const SelectInput = (props) => {
    return (
        <span className="max-width">
            <FormControl
                id={props.id}
                componentClass={"select"}
                name={props.name}
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                className={props.className}
            >
                <option disabled value={EMPTY_STRING} >{props.disabled ? EMPTY_STRING : props.placeholder}</option>
                {props.selectInput && props.selectInput.filter((option) => option.name === props.name).map((item, i) => {
                    return (
                        <option key={i} value={item.value}> {item.label} </option>
                    );
                })}
            </FormControl>

            {!props.hideIcon &&
                <FormControl.Feedback>
                    <span className="mr-15 mt-8">
                        <FontAwesomeIcon icon="caret-down" />
                    </span>
                </FormControl.Feedback>
            }
        </span>
    )
}

export default SelectInput;